import React from "react";
import Grid from "@mui/material/Grid";

export const Col = function ({ children, size, ...props }: any){
    return (<Grid size={size} {...props}>{children}</Grid>);
}


export default Col;